// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"e8924f86","970":"debee951"}[chunkId] + ".chunk.css";
};